import { render, staticRenderFns } from "./LottoBody.vue?vue&type=template&id=f16075aa&"
import script from "./LottoBody.vue?vue&type=script&lang=ts&"
export * from "./LottoBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports